import { render, staticRenderFns } from "./WaitingForPackageModal.vue?vue&type=template&id=6ce8938c&scoped=true&"
import script from "./WaitingForPackageModal.vue?vue&type=script&lang=js&"
export * from "./WaitingForPackageModal.vue?vue&type=script&lang=js&"
import style0 from "./WaitingForPackageModal.vue?vue&type=style&index=0&id=6ce8938c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce8938c",
  null
  
)

export default component.exports